<template>
  <v-row v-if="openFlag" class="ma-8">
    <v-col cols="8" offset="2">
      <v-card class="pa-2" tile color="black">
        <d-player ref="player" :options="options"></d-player>
      </v-card>
    </v-col>
    <v-col cols="8" offset="2" class="text-h6">视频教程介绍</v-col>
    <v-col cols="8" offset="2" v-html="tutorial.note"></v-col>
  </v-row>

  <v-container v-else class="fill-height">
    <div class="text-h3 text-center grey--text" style="width:100%;">
      正在准备中,请关注系统公告
    </div>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import DPlayer from 'vue-dplayer';
import 'vue-dplayer/dist/vue-dplayer.css';
import { getTutorial } from '@/plugins/api';

export default {
  data () {
    return {
      openFlag: true,
      tutorial: {},
      options: {
        logo: `${this.Utility.RES_SERVER}/static/img/logo.png`
      }
    }
  },
  created () {
    this.init();
  },
  methods: {
    init () {
      if (this.openFlag) {
        getTutorial().then(res => {
          this.tutorial = res.data;
          let url = this.Utility.RES_SERVER + this.tutorial.url;
          this.$refs.player.dp.switchVideo({
            url: url,
            type: 'auto'
          });
        })
      }
    }
  },
  components: {
    DPlayer: DPlayer
  }
}
</script>